/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type NewsListNewsRequest = {
  perPage?: number | null;
  page?: number | null;
  keyword?: string | null;
  sort?: string | null;
  direction?: NewsListNewsRequest.direction | null;
};

export namespace NewsListNewsRequest {
  export enum direction {
    ASC = "asc",
    DESC = "desc",
  }
}
